<template>
  <div class="asc-fault-report-by-flight-grid-wrapper">
    <asc-grid-wrapper-header :title="title"> </asc-grid-wrapper-header>
    <template v-if="loading">
      <asc-spinner-wrapper loading></asc-spinner-wrapper>
    </template>
    <template v-if="!loading">
      <asc-fault-report-by-flight-grid
        :values="values"
        :on-open-raw-report="onOpenRawReport"
        :on-view-details="onViewDetails"
        :on-visualize="onVisualize"
      ></asc-fault-report-by-flight-grid>
    </template>
  </div>
</template>

<script>
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscGridWrapperHeader from '@/components/molecules/AscGridWrapperHeader'
import AscFaultReportByFlightGrid from '@/components/molecules/AscFaultReportByFlightGrid'

export default {
  name: 'AscFaultReportByFlightGridWrapper',

  components: {
    AscSpinnerWrapper,
    AscGridWrapperHeader,
    AscFaultReportByFlightGrid,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    values: {
      type: Array,
      default: () => [],
    },
    onOpenRawReport: {
      type: Function,
      default: () => {},
    },
    onViewDetails: {
      type: Function,
      default: () => {},
    },
    onVisualize: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
.asc-fault-report-by-flight-grid-wrapper {
  background-color: $primary-white;

  .asc-grid-wrapper-title {
    .asc-header--h1 {
      height: 24px;
      color: $gray-1000 !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      letter-spacing: 1px !important;
      line-height: 18px !important;
    }
  }
}
</style>
